module.exports = __webpack_public_path__ + "img/massa.9ce1dfe1.png";